module.exports = __webpack_public_path__ + "img/block_bg2.0e70172b.webp";